export const InstallmentsParams = {
  ORGANIZATION_CODE: 'organizationCode',
  AMOUNT: 'amount',
  CARD_UID: 'cardUid',
};
